/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import { FontSizes, FontWeights, getTheme, Icon } from "@fluentui/react";
import React from "react";
const theme = getTheme();
export const ShowMeta = (): JSX.Element => {
    return <div style={{ fontWeight: FontWeights.regular, fontSize: FontSizes.smallPlus, color: theme.palette.neutralPrimary }}>
        <h3>For each selected location you can update metadata accordingly</h3>
        <p> Selecting both document library or a SharePoint list opens a new panel with all the metadata of the library or the list</p>



        <div style={{ textAlign: 'center' }}>
            <img width='200' src={require('../../../assets/6.png')} />
        </div>
        <p>If you select SharePoint ypou have the option to save into list <Icon iconName='NumberedListText' /> </p>
        <div style={{ textAlign: 'center' }}>
            <img width='200' src={require('../../../assets/11.png')} />
        </div>
        <p>Select to save to list you can also automatically create the basic fields (Subject, from  etc)</p>


    </div>;
};
